<div acaActiveLink="action-button--active">
  <ng-container *ngFor="let node of siteContainers$ | async">
    <div class="button-layout">
      <ng-container *ngIf="data.state === 'expanded'">
        <div
          [ngStyle]="{
            'padding-left': '12px'
          }"
          class="icon-layout wk-container-btn btn-{{ node.id }}-container"
        >
          <span
            *ngIf="containerSelected === node.name"
            (click)="collapseContainer()"
            (keyup)="collapseContainer()"
            class="wk-icon-folder-open"
          >
          </span>
          <span
            *ngIf="containerSelected !== node.name"
            (click)="expandContainer(node)"
            (keyup)="expandContainer(node)"
            class="wk-icon-folder"
          >
          </span>
        </div>
        <button
          #item
          class="container-button wk-container-btn btn-{{ node.id }}-container"
          [attr.title]="(siteContainerLabels[node.name]?.label | translate) || node.name"
          (click)="containerClicked(node)"
        >
          <span
            class="wk-title"
            [ngClass]="{ 'wk-title--active': containerSelected === node.name }"
            *ngIf="data.state === 'expanded'"
          >
            {{ (siteContainerLabels[node.name]?.label | translate) || node.name }}
          </span>
        </button>
      </ng-container>
      <ng-container *ngIf="data.state === 'collapsed'">
        <div class="icon-layout">
          <button
            class="container-button wk-container-btn btn-{{
              node.id
            }}-container"
            title=" {{ node.title || node.name }}"
            (click)="containerClicked(node)"
          >
            <span class="wk-icon-folder"></span>
          </button>
        </div>
      </ng-container>
    </div>
    <ng-container
      *ngIf="
        data.state === 'expanded' &&
        containerSelected &&
        containerSelected === node.name
      "
    >
      <adf-tree-view-list
        [nodeId]="node.id"
        (nodeClicked)="onClickTreeItem($event)"
        (error)="onErrorOccurred($event)"
      ></adf-tree-view-list>
    </ng-container>
  </ng-container>
</div>
